import * as React from 'react';
import { IStandardOffer, standard } from '../../settings';
import { OfferCard } from './components/OfferCard';
import { StandardModal } from './components/StandardModal';
import { StandardCarousel } from './components/StandardCarousel';
import { StandardLayout } from './components/StandardLayout';
import { OfferList } from './components/OfferList/OfferList';

export function Standard() {
  const navRef = {
    next: React.useRef<HTMLButtonElement>(null),
    prev: React.useRef<HTMLButtonElement>(null),
  };

  const [isVisibleModal, setIsVisibleModal] = React.useState(false);
  const [activeOffer, setActiveOffer] = React.useState<IStandardOffer | null>(null);

  const clickOfferCardHandle = (feature: IStandardOffer) => {
    setActiveOffer(feature);
    setIsVisibleModal(true);
  };

  return (
    <>
      <StandardLayout
        title={standard.title}
        description={standard.description}
        navRef={navRef}
        carousel={
          <StandardCarousel navRef={navRef}>
            {standard.features.map(feature => {
              return (
                <OfferList
                  key={feature.id}
                  title={feature.title}
                  offersLength={feature.offers.length}
                  offers={feature.offers.map(item => (
                    <OfferCard key={item.id} offer={item} onClick={clickOfferCardHandle} />
                  ))}
                />
              );
            })}
          </StandardCarousel>
        }
      />
      {activeOffer && (
        <StandardModal
          open={isVisibleModal}
          onClose={setIsVisibleModal}
          content={activeOffer.description}
          imageUrls={activeOffer.media}
          modalTitle={standard.title}
          title={activeOffer.title}
        />
      )}
    </>
  );
}
